import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#button-style" }),
  /*#__PURE__*/_createTextVNode(" Button style ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, " Radio with button styles. ", -1)
const _hoisted_4 = { class: "rounded border p-10" }
const _hoisted_5 = { style: {"margin-top":"20px"} }
const _hoisted_6 = { style: {"margin-top":"20px"} }
const _hoisted_7 = { style: {"margin-top":"20px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_radio_button = _resolveComponent("el-radio-button")
  const _component_el_radio_group = _resolveComponent("el-radio-group")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode("div", null, [
        _createVNode(_component_el_radio_group, {
          modelValue: _ctx.radio1,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.radio1 = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_button, { label: "New York" }),
            _createVNode(_component_el_radio_button, { label: "Washington" }),
            _createVNode(_component_el_radio_button, { label: "Los Angeles" }),
            _createVNode(_component_el_radio_button, { label: "Chicago" })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_el_radio_group, {
          modelValue: _ctx.radio2,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.radio2 = $event)),
          size: "medium"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_button, { label: "New York" }),
            _createVNode(_component_el_radio_button, { label: "Washington" }),
            _createVNode(_component_el_radio_button, { label: "Los Angeles" }),
            _createVNode(_component_el_radio_button, { label: "Chicago" })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode(_component_el_radio_group, {
          modelValue: _ctx.radio3,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.radio3 = $event)),
          size: "small"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_button, { label: "New York" }),
            _createVNode(_component_el_radio_button, {
              label: "Washington",
              disabled: ""
            }),
            _createVNode(_component_el_radio_button, { label: "Los Angeles" }),
            _createVNode(_component_el_radio_button, { label: "Chicago" })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode(_component_el_radio_group, {
          modelValue: _ctx.radio4,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.radio4 = $event)),
          disabled: "",
          size: "mini"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_button, { label: "New York" }),
            _createVNode(_component_el_radio_button, { label: "Washington" }),
            _createVNode(_component_el_radio_button, { label: "Los Angeles" }),
            _createVNode(_component_el_radio_button, { label: "Chicago" })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createVNode(_component_CodeHighlighter, {
        "field-height": 400,
        lang: "html"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code4), 1)
        ]),
        _: 1
      })
    ])
  ]))
}